import "core-js/modules/es.array.push.js";
export default {
  name: 'pbl_sn',
  data() {
    return {
      list: [],
      singleform: {
        limit: 100,
        page: 1
      },
      screenName: '',
      columnForm: {
        limit: 100,
        page: 1
      },
      detailList: [],
      t_url: {},
      listTotal: 0,
      pageNum: 1,
      datas: []
    };
  },
  methods: {
    // 获取页面配置
    getConfig() {
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.formId = 215424;
      this.singleform.formUserId = this.$route.query.formUserId;
      this.$api.getListByUserId(this.singleform).then(res => {
        if (!res.formUserList || !res.formUserList.length) return;
        this.screenName = res.formUserList[0].formData.find(item => {
          return item.id == 3;
        }) ? res.formUserList[0].formData.find(item => {
          return item.id == 3;
        }).values[0].val : '';
        this.config = {
          formId_a: 112720,
          formId_3d: 113010,
          formId_column: 112712
        };
        this.getsingleformList();
      });
    },
    // 获取文物列表
    getsingleformList() {
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.formId = this.config.formId_3d;
      this.$api.singleadvanceSearch(this.singleform).then(res => {
        this.listTotal = res.totalPage;
        this.setData(res.dataList);
      });
    },
    setData(data) {
      data = data.map((item, index) => {
        let nItem = {
          columnName: this.getValInFormData(item.formIdValueData, 'column'),
          name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'objectId', 'suffix'),
          code: this.getValInFormData(item.formIdValueData, 'autoId'),
          type: this.getValInFormData(item.formIdValueData, 'type'),
          touchType: this.getValInFormDatas(item.formIdValueData, 'touchType', 'val'),
          autoCode: this.getValInFormData(item.formIdValueData, 'autoId'),
          images_360: this.getValInFormDatas(item.formIdValueData, 'panorama', 'objectId', 'suffix'),
          images: this.getValInFormDatas(item.formIdValueData, 'image', 'objectId', 'suffix'),
          vide: this.getValInFormDatas(item.formIdValueData, 'video', 'objectId')
        };
        if (nItem.type == '3D') {
          let data_3d = item.formIdValueData.angleX.groupValues;
          nItem.attribute3d = {
            zoomRatio: this.getValInFormData(item.formIdValueData, 'zoom', ''),
            pointLight: this.getValInFormData(item.formIdValueData, 'pointLight', ''),
            pointColor: this.getValInFormData(item.formIdValueData, 'pointLightColor', ''),
            highlight: this.getValInFormData(item.formIdValueData, 'highLight', ''),
            envLight: this.getValInFormData(item.formIdValueData, 'environmentLight', ''),
            envColor: this.getValInFormData(item.formIdValueData, 'environmentColor', ''),
            parallelLight: this.getValInFormData(item.formIdValueData, 'parallelLight', ''),
            modelCenter: this.getValInFormData(item.formIdValueData, 'modelCenter', '')
          };
          nItem.attributeModels = data_3d.map((d, index) => {
            let target = {
              angleX: parseFloat(this.getValInFormData(item.formIdValueData, 'angleX', '', '', index)),
              angleY: parseFloat(this.getValInFormData(item.formIdValueData, 'angleY', '', '', index)),
              angleZ: parseFloat(this.getValInFormData(item.formIdValueData, 'angleZ', '', '', index)),
              axisX: parseFloat(this.getValInFormData(item.formIdValueData, 'axisX', '', '', index)),
              axisY: parseFloat(this.getValInFormData(item.formIdValueData, 'axisY', '', '', index)),
              axisZ: parseFloat(this.getValInFormData(item.formIdValueData, 'axisZ', '', '', index)),
              modelName: this.getValInFormData(item.formIdValueData, 25, 'objectId', '', index),
              mtlName: this.getValInFormData(item.formIdValueData, 23, 'objectId', '', index),
              normalPath: this.getValInFormData(item.formIdValueData, 26, 'objectId', 'suffix', index),
              chartlet: this.getValInFormData(item.formIdValueData, 24, 'objectId', 'suffix', index),
              modelPath: this.getValInFormData(item.formIdValueData, 25, 'objectId', '', index)
            };
            this.setTurlImg(item.formIdValueData, 24, 'name', index);
            // this.t_url[this.getValInFormData(item.formIdValueData, 24, 'name', '', index)] = target.chartlet
            return target;
          });
        }
        return nItem;
      });
      data = data.filter(item => {
        return item.touchType.indexOf(this.screenName) > -1;
      });
      data.length < 40 && this.pageNum == 1 ? this.list = data.concat(data) : this.list = data;
      this.getDetailList();
    },
    setTurlImg(data, id, type, index) {
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      data[id].groupValues[index].values[0].map(item => {
        let t_name_str = item.name.toLocaleLowerCase();
        this.t_url[t_name_str] = `${item.objectId}.${item.suffix}`;
      });
    },
    getValInFormData(data, id, type, type2, index) {
      index = index || 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target = data[id].groupValues[index].values[0];
      target = (type ? target[0][type] : target[0].val) + (type2 ? `.${target[0][type2]}` : '');
      return target;
    },
    getValInFormDatas(data, id, key, type) {
      let target = data[id];
      if (!target) return '';
      target = target.groupValues[0];
      target = target.values[0].map(item => {
        return item[key] + (type ? `.${item[type]}` : '');
      });
      return target.join(',');
    },
    getValInFormDataFiles(data, id, type) {
      let targets = [];
      data.map(item => {
        let target = item.find(d => {
          return d.alias == id;
        });
        if (!target || !target.values[0]) return;
        target = target.values[0][type];
        targets.push(target);
      });
      return targets;
    },
    getDetailList() {
      this.columnForm.deptId = this.$route.query.fid || '151066';
      this.columnForm.formId = 112720;
      this.$api.singleadvanceSearch(this.columnForm).then(res => {
        this.detailList = res.dataList.map(item => {
          let data = {
            description: this.getValInFormData(item.formIdValueData, 'description'),
            audio: this.getValInFormData(item.formIdValueData, 'audio', 'objectId'),
            code: this.getValInFormData(item.formIdValueData, 'autoId')
          };
          return data;
        });
        this.setJson();
      });
    },
    setJson() {
      let datas = this.list.map(item => {
        let target = this.detailList.find(d => {
          return d.code == item.code;
        });
        if (target) {
          item.description = target.description;
          item.audio = target.audio;
          item.fid = this.$route.query.fid;
        }
        return item;
      });
      this.datas = this.datas.concat(datas);
      if (this.pageNum < this.listTotal) {
        this.pageNum += 1;
        this.singleform.page = this.pageNum;
        this.columnForm.page = this.pageNum;
        this.getsingleformList();
      } else {
        // return console.log(this.datas, this.t_url)
        var content = JSON.stringify({
          data: datas,
          t_url: this.t_url
        });
        var blob = new Blob([content], {
          type: "text/plain;charset=utf-8"
        });
        saveAs(blob, "data.json");
      }
    }
  },
  created() {
    this.getConfig();
    let list1 = ['FileSaver.js'];
    list1.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/${item}`;
      document.body.appendChild(oScript);
    });
  },
  computed: {}
};